<template>
  <div>
    <KTCodePreview v-bind:title="'In đơn hàng'">
      <template v-slot:toolbar>
        <b-button
          variant="primary"
          size="sm"
          class="font-weight-bolder"
          @click="printData"
          :disabled="isLoading || !dataset.id"
          style="width: max-content"
        >
          <b-spinner v-if="isLoading" small class="mr-2"></b-spinner>
          <i v-else style="font-size: 1rem" class="fas fa-print"></i>
          {{ isLoading ? 'Đang tải...' : 'In đơn hàng' }}
        </b-button>
      </template>
      <template v-slot:preview>
        <!-- Loading state -->
        <div v-if="isLoading" class="text-center p-4">
          <b-spinner variant="primary"></b-spinner>
          <p class="mt-2">Đang tải dữ liệu đơn hàng...</p>
        </div>

        <!-- Error state -->
        <div v-else-if="error" class="alert alert-danger">
          <h5>Lỗi tải dữ liệu</h5>
          <p>{{ error }}</p>
          <b-button variant="outline-primary" size="sm" @click="retryLoadData">
            Thử lại
          </b-button>
        </div>

        <!-- Content -->
        <div v-else>
          <hr
            class="hr-text"
            data-content="Khổ giấy A4- A5"
            style="font-weight: 600"
          />
          <div id="A4">
            <PrintOrderA4 :payload="dataset" />
          </div>
        </div>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import PrintOrderA4 from '../../components/order/PrintOrderA4.vue';
import ApiService from '@/core/services/api.service';
import moment from 'moment';
import _ from 'lodash';
import { ITEM_TYPE, PRODUCT_TYPE } from '@/utils/enum.js';
import {
  makeToastFaile,
  convertPrice,
  calculateDiscountAmount,
  cloneDeep,
  catchNum,
} from '@/utils/common.js';
import { mapGetters } from 'vuex';
import { EventBus } from '@/core/services/event-bus';

export default {
  data() {
    return {
      barcode: 'barcode',
      ITEM_TYPE: ITEM_TYPE,
      PRODUCT_TYPE: PRODUCT_TYPE,
      isLoading: false,
      error: null,
      dataset: {
        id: '',
        storeId: '',
        storeAddress: '',
        storeName: '',
        status: '',
        customerNote: '',
        checkDate: '',
        checkTime: '',
        codeShip: '',
        discountAmount: '',
        transferAmount: '',
        depositAmount: '',
        paymentDate: '',
        customerShipFee: '',
        shipFee: '',
        orderSourceId: '',
        saleNote: '',
        orderItems: [],
        createdAt: '',
        createdBy: '',
        customerId: '',
        customerName: '',
        customerMobile: '',
        customerAddress: '',
        cashAccountName: '',
        transferAccountName: '',
        saleId: '',
        creditAmount: '',
        installedMoneyAmount: 0,
        totalAmount: 0,
      },
      currentDay: moment(new Date()).format('DD/MM/YYYY'),
      employeeName: 'Trung',
      orderId: null,
      dataCache: new Map(),
    };
  },
  async created() {
    const orderId = this.$route.query.id || null;
    if (!orderId) {
      this.error = 'Yêu cầu mã id đơn hàng';
      makeToastFaile('Yêu cầu mã id đơn hàng');
      return;
    }
    this.orderId = orderId;
    await this.loadOrderData(orderId);
  },
  methods: {
    catchNum,
    convertPrice,

    async retryLoadData() {
      if (this.orderId) {
        this.error = null;
        await this.loadOrderData(this.orderId);
      }
    },

    async loadOrderData(orderId) {
      this.isLoading = true;
      this.error = null;

      try {
        const cacheKey = `order_${orderId}`;
        if (this.dataCache.has(cacheKey)) {
          this.dataset = this.dataCache.get(cacheKey);
          this.isLoading = false;
          EventBus.$emit('order-fetched', this.dataset);
          return;
        }

        const orderData = await this.getOrderById(orderId);
        if (orderData) {
          await this.loadRelatedData(orderData);
          this.dataCache.set(cacheKey, this.dataset);
          EventBus.$emit('order-fetched', this.dataset);
        } else {
          this.error = 'Không thể tải dữ liệu đơn hàng';
        }
      } catch (error) {
        this.error = error.message || 'Có lỗi xảy ra khi tải dữ liệu';
        makeToastFaile(this.error);
      } finally {
        this.isLoading = false;
      }
    },

    async loadRelatedData(orderData) {
      const promises = [];

      if (orderData.customerId) {
        promises.push(this.getCustomerInfoById(orderData.customerId));
      }

      if (orderData.storeId) {
        promises.push(this.getStoreById(orderData.storeId));
      }

      if (promises.length > 0) {
        const results = await Promise.allSettled(promises);
        results.forEach((result, index) => {
          if (result.status === 'rejected') {
            console.warn(
              `Failed to load related data ${index}:`,
              result.reason,
            );
          }
        });
      }
    },

    htmlIsShow(item, action) {
      let check = false;
      switch (action) {
        case 'isCombo': {
          check = item.productType === PRODUCT_TYPE.PRODUCT_COMBO;
          break;
        }
        case 'haveImei': {
          check = item.imeiCode && item.imeiCode.trim().length > 0;
          break;
        }
        case 'isItemGift': {
          check = item.orderItemType === ITEM_TYPE.GIFT;
          break;
        }
      }
      return check;
    },

    sumAmountItem(item) {
      const quantity = Number(item.quantity) || 0;
      const productPrice = Number(item.productPrice) || 0;
      const totalAmountItem = quantity * productPrice;
      const discountProducts = this.discountByMany(item, quantity);

      return totalAmountItem - discountProducts;
    },

    discountByMany(item, quantity) {
      const quantityItem = quantity
        ? quantity
        : item.quantity
        ? Number(item.quantity)
        : 0;
      const discountOfOneProduct = this.discountByOne(item);
      return quantityItem * discountOfOneProduct;
    },

    discountByOne(item) {
      const discountAmount = Number(item.discountAmount) || 0;
      const discountType = Number(item.discountType) || 1;
      const quantity = Number(item.quantity) || 0;
      const productPrice = Number(item.productPrice) || 0;

      const discountAProduct = calculateDiscountAmount(
        discountAmount,
        discountType,
        productPrice,
        quantity,
      );
      return discountAProduct;
    },

    printData() {
      let prtHtml = null;
      prtHtml = document.getElementById('printMe').innerHTML;
      let stylesHtml = '';
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      const WinPrint = window.open(
        '',
        '',
        'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0',
      );

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
          <style>
          * {
            box-sizing: border-box;
            -moz-box-sizing: border-box;
            -webkit-print-color-adjust: exact !important;
            color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          html, body {
            margin: 0;
            padding: 0;
          }
          @media print {
            html,
            body {
              margin: 0 !important;
              padding: 0 !important;
              min-height: 0 !important;
              height: auto !important;
              width: auto !important;
              overflow: visible !important;
              font-family: Time New Roman, sans-serif;
            }
            .container {
              -webkit-print-color-adjust: exact;
              --primary-color: #000000;
              position: relative;
              width: 100% !important;
              max-width: 100% !important;
              margin: 0 !important;
              padding: 0 !important;
              min-height: 0 !important;
              page-break-inside: avoid;
              break-inside: avoid-page;
            }

            .container::before {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
              content: '';
              display: block;
              position: absolute;
              left: 0;
              top: 40px;
              width: 100%;
              height: auto;
              max-height: 120mm;
              opacity: 0.2;
              background-image: url(/media/logos/clickbuy-v1.png);
              background-repeat: no-repeat;
              background-position: center;
              background-size: contain;
            }
            @page {
              size: A5 landscape;
              margin: 8mm;
              -webkit-print-color-adjust: exact;
            }

            table,
            .signing,
            .note,
            .products {
              page-break-inside: avoid;
              break-inside: avoid-page;
            }

            footer {
              position: relative !important;
              bottom: auto !important;
              left: auto !important;
              width: 100%;
              height: 40px;
              margin-top: 16px;
              background-color: #000;
              color: #fff;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0 40px;
              page-break-inside: avoid;
              break-inside: avoid-page;
            }

            footer p {
              margin-bottom: 0;
              color: #fff !important;
            }
          }
          .container {
            -webkit-print-color-adjust: exact;
            --primary-color: #000000;
            position: relative;
            width: 100% !important;
            max-width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
          }

          .container::before {
            content: '';
            display: block;
            position: absolute;
            left: 0;
            top: 40px;
            width: 100%;
            height: auto;
            max-height: 120mm;
            opacity: 0.2;
            background-image: url(/media/logos/clickbuy-v1.png);
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
          }
          .text-center {
            text-align: center;
          }

          .text-right {
            text-align: right;
          }

          .font-size-large {
            font-size: 18px;
            color: var(--primary-color);
            margin: 0 0 4px;
            line-height: 1.2;
          }

          .font-size-print {
            color: var(--primary-color);
            font-size: 16px;
          }

          .text-bold-500 {
            font-weight: 500;
          }

          .text-bold-400 {
            font-weight: 400;
          }

          .header {
            height: 90px;
            max-height: 90px;
            display: flex;
            flex-direction: row;
            align-items: center;
            overflow: hidden;
          }

          .header .logo {
            flex: 1;
          }

          .header .order-info {
            flex: 1;
            display: inline-block;
            text-align: center;
          }

          .header .order-info .order-detail {
            display: flex;
            justify-content: center;
            gap: 32px;
          }

          .logo img {
            object-fit: contain;
            max-width: 100%;
            max-height: 55px;
          }

          .order-info {
            display: flex;
            justify-content: center;
          }

          .information {
            height: fit-content;
            display: flex;
            gap: 20px;
          }

          .information .company {
            flex-basis: calc(50% - 20px);
            border: 0.5px solid black;
            border-radius: 4px;
            padding: 10px;
          }

          .information .customer {
            flex-basis: 50%;
            border: 0.5px solid black;
            border-radius: 4px;
            padding: 10px;
          }

          .information p {
            margin-bottom: 0px;
            line-height: 1.4;
          }

          .products {
            margin-top: 20px;
          }

          table {
            width: 100%;
          }

          table,
          th,
          td {
            border: 1px solid black;
            padding: 8px;
          }

          .signing {
            display: flex;
            height: 100px;
            margin-top: 20px;
          }

          .sign-customer,
          .sign-sale,
          .sign-accountant {
            flex: 30%;
            text-align: center;
          }

          .sign-customer::after,
          .sign-sale::after,
          .sign-accountant::after {
            content: '(Ký, họ tên)';
            display: inherit;
            font-style: italic;
            font-size: 16px;
          }
          .note {
            margin-top: 20px;
          }
          </style>
        </head>
        <body>`);
      WinPrint.document.write(`${prtHtml}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(function() {
        WinPrint.print();
      }, 500);
    },

    async getDistrictById(cityId, districtId) {
      try {
        const response = await ApiService.get(`city/${cityId}/district`);
        const { data } = response.data;
        const districtKey = _.keyBy(data, 'id');
        const district = districtKey[districtId];
        if (district) {
          this.dataset.customerDistrict = district.name;
        }
      } catch (error) {
        console.warn('Failed to load district:', error);
      }
    },

    async getWardById(districtId, wardId) {
      try {
        const response = await ApiService.get(`city/${districtId}/ward`);
        const { data } = response.data;
        const wardKey = _.keyBy(data, 'id');
        const ward = wardKey[wardId];
        if (ward) {
          this.dataset.customerWard = ward.name;
        }
      } catch (error) {
        console.warn('Failed to load ward:', error);
      }
    },

    async getOrderById(orderId) {
      try {
        const response = await ApiService.query(`/v1/orders/${orderId}`);
        const { data, status, message } = response.data;

        if (!status) {
          throw new Error(message || 'Không thể tải thông tin đơn hàng');
        }

        data.orderItems = this.getOrderItems(data);

        const sumPayment =
          catchNum(data.installedMoneyAmount) +
          catchNum(data.creditAmount) +
          catchNum(data.transferAmount) +
          catchNum(data.depositAmount);

        const totalAmountToPay = data.totalAmount - sumPayment;
        let totalUnitPrice = 0;
        let totalQuantity = 0;
        let totalDiscountAmount = 0;

        data.orderItems.forEach((product) => {
          totalUnitPrice += product.productPrice;
          totalQuantity += product.quantity;
          totalDiscountAmount += product.discountAmount;
        });

        data.sumPayment = sumPayment;
        data.totalAmountToPay = totalAmountToPay;
        data.totalUnitPrice = totalUnitPrice;
        data.totalQuantity = totalQuantity;
        data.totalDiscountAmount = totalDiscountAmount;

        this.dataset = data;
        return data;
      } catch (error) {
        console.error('Error fetching order:', error);
        throw error;
      }
    },

    getOrderItems(data) {
      const terms = cloneDeep(data.orderItems);
      const mainItems = terms.filter(
        (item) => item.orderItemType === ITEM_TYPE.MAIN,
      );
      const childItems = terms.filter(
        (item) => item.orderItemType !== ITEM_TYPE.MAIN,
      );
      let orderItems = [];
      mainItems.map((main) => {
        orderItems.push(main);
        const filteredItems = childItems.filter(
          (child) => child.belongOrderDetailId === main.id,
        );
        orderItems = orderItems.concat(filteredItems);
      });
      return orderItems;
    },

    async getCustomerInfoById(customerId) {
      try {
        const response = await ApiService.get(`v1/customers/${customerId}`);
        const { data, status, message } = response.data;

        if (!status) {
          console.warn('Failed to load customer info:', message);
          return;
        }

        const customerName = this.dataset.customerName || data.fullName;
        const customerAddress = this.dataset.customerAddress || data.address;

        this.dataset.customerName = customerName;
        this.dataset.customerAddress = customerAddress;

        const locationPromises = [];

        if (data.city && data.district) {
          locationPromises.push(this.getDistrictById(data.city, data.district));
        }

        if (data.district && data.ward) {
          locationPromises.push(this.getWardById(data.district, data.ward));
        }

        if (locationPromises.length > 0) {
          await Promise.allSettled(locationPromises);
        }
      } catch (error) {
        console.error('Error fetching customer info:', error);
      }
    },

    async getStoreById(storeId) {
      if (!storeId) {
        return;
      }

      try {
        const response = await ApiService.query(`v1/stores/${storeId}`);
        const { data, status, message } = response.data;

        if (status && data) {
          this.dataset.storeAddress = data.address;
        } else {
          console.warn('Failed to load store info:', message);
        }
      } catch (error) {
        console.error('Error fetching store info:', error);
      }
    },

    getAddressCustomer(dataset) {
      const data = {
        customerAddress: dataset.customerAddress,
        customerWard: dataset.customerWard,
        customerDistrict: dataset.customerDistrict,
        customerCity: dataset.customerCity,
      };

      const pickedByData = _.pickBy(data);
      if (_.isEmpty(pickedByData)) return '';
      return Object.values(pickedByData).join(',');
    },
  },
  components: {
    KTCodePreview,
    PrintOrderA4,
  },
  computed: {
    computedData() {
      return this.dataset.slice();
    },
    ...mapGetters(['layoutConfig']),
    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'));
    },
    loaderLogo() {
      return this.layoutConfig('loader.logo');
    },
    sumDiscountHeader() {
      const order = this.dataset;
      const discountAmount = order.discountAmount;
      const discountType = order.discountType || 1;
      const totalAmount = this.sumTotalAmount;
      const discountTotalAmount = calculateDiscountAmount(
        discountAmount,
        discountType,
        totalAmount,
      );
      return discountTotalAmount;
    },
    sumShipFee() {
      const order = this.dataset;
      const customerShipFee = Number(order.customerShipFee) || 0;
      const shipFee = Number(order.shipFee) || 0;
      return customerShipFee + shipFee;
    },
    sumDiscountItemsAmount() {
      const orderItems = this.dataset.orderItems || [];
      const distcountAmountItems = orderItems.reduce((result, current) => {
        const discount = this.discountByMany(current);
        return result + discount;
      }, 0);
      return distcountAmountItems;
    },
    sumDiscountAmount() {
      const distcountAmountItems = this.sumDiscountItemsAmount;
      const discountTotalAmount = this.sumDiscountHeader;
      return discountTotalAmount + distcountAmountItems;
    },
    sumTotalFinal() {
      const sumDiscountHeader = this.sumDiscountHeader;
      const totalAmount = this.sumTotalAmount;
      const shipFee = this.sumShipFee;
      return totalAmount + shipFee - sumDiscountHeader;
    },
    sumTotalAmount() {
      const orderItems = this.dataset.orderItems || [];
      const sumOrderItems = orderItems.reduce((result, item) => {
        if (item.orderItemType !== ITEM_TYPE.GIFT) {
          const sumAmountItem = this.sumAmountItem(item);
          result += sumAmountItem;
        }
        return result;
      }, 0);
      return sumOrderItems;
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Đơn hàng', route: '/orders' },
      { title: 'In đơn hàng' },
    ]);
  },
};
</script>

<style scoped>
.header-print {
  text-align: center;
  width: 100%;
}
.font-size-print {
  font-size: 13px;
}
.font-size-name {
  font-size: 13px;
}
.container-header {
  display: flex;
}
.container-header > div:first-child {
  margin-right: auto;
  visibility: hidden;
}
.container-header > div:last-child {
  margin-left: auto;
}
</style>
